import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'

import {
  AuthenticationResult,
  EventMessage,
  EventType,
  PublicClientApplication,
} from '@azure/msal-browser'

import App from './App'
import { msalConfig } from './utils/auth'
import './utils/i18n'

export const msalInstance = new PublicClientApplication(msalConfig)

msalInstance.initialize().then(() => {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  const accounts = msalInstance.getAllAccounts()
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0])
  }

  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult
      const account = payload.account
      msalInstance.setActiveAccount(account)
    }
  })
  const rootElement = document.getElementById('root') as HTMLElement
  const root = ReactDOM.createRoot(rootElement)

  root.render(
    <React.StrictMode>
      <Suspense fallback="Loading ...">
        <App publicClientApplication={msalInstance} />
      </Suspense>
    </React.StrictMode>,
  )
})
